import { render, staticRenderFns } from "./ServiceActivesList.vue?vue&type=template&id=3ba27b30"
import script from "./ServiceActivesList.vue?vue&type=script&lang=js"
export * from "./ServiceActivesList.vue?vue&type=script&lang=js"
import style0 from "./ServiceActivesList.vue?vue&type=style&index=0&id=3ba27b30&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba27b30')) {
      api.createRecord('3ba27b30', component.options)
    } else {
      api.reload('3ba27b30', component.options)
    }
    module.hot.accept("./ServiceActivesList.vue?vue&type=template&id=3ba27b30", function () {
      api.rerender('3ba27b30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServiceActivesList.vue"
export default component.exports